import { unwrapResult } from '@reduxjs/toolkit'
import {
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  ModalProps,
  notification,
  Radio,
  Row,
  Select,
  Tag,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  getTeantTypeName,
  getTenantCategoryName,
  getTenantLevelName,
  HospitalLevels,
  teantTypes,
  TenantCategory,
  TenantLevel,
  TenantLevels,
} from '../../models/tenant'
import { getPartnerPlatformList } from '../partnerPlatform/PartnerPlatformSlice'
import { ChooseVersionModal } from './chooseVersionModal'
import {
  createOrUpdateTenant,
  getProvinceList,
  getTenantDetail,
  getTenantLabelList,
  getTenantList,
} from './tenantSlice'

interface TenantModalProps {
  tenantId?: string
  versionName?: any
}

export const TenantModal = ({
  versionName,
  tenantId,
  onCancel,
  onOk,
  ...others
}: TenantModalProps & ModalProps): ReactElement => {
  const { CheckableTag } = Tag
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [isLoading, setIsLoading] = useState(false)

  const [platformOption, setPlatformOption] = useState([])

  const rowProps = {
    gutter: 4,
  }

  const [name, setName] = useState<any>()

  const [labelList, setLabelList] = useState<any>([])

  const [selectedTags, setSelectedTags] = useState<string[]>([])

  const colProps = { span: 8 }

  const firstColumnLayout = {
    labelCol: { flex: '6.5rem' },
    wrapperCol: { span: 16 },
  }

  const middleColumnLayout = {
    labelCol: { flex: '8rem' },
    wrapperCol: { span: 14 },
  }
  const labelLayout = {
    labelCol: { flex: '6rem' },
  }

  const wideColumnLayout = {
    labelCol: { flex: '6.5rem' },
    wrapperCol: { flex: 1 },
  }

  const required = {
    rules: [
      {
        required: true,
      },
    ],
  }

  const [
    isChooseVersionModalVisible,
    setIsChooseVersionModalVisible,
  ] = useState(false)

  const [provinceList, setProvinceList] = useState<any[]>()

  const [cityList, setCityList] = useState<any[]>()

  const [AreaList, setAreaList] = useState<any[]>()

  const [provinceState, setProvinceState] = useState<any>()

  const [cityState, setCityState] = useState<any>()

  const [versionId, setVersionId] = useState<any>()

  const [tenantIdList, setTenantIdList] = useState<any>()

  const [showData, setShowData] = useState<any>(provinceState)

  const whsjjkList = [
    {
      name: '不对接',
      value: 0,
    },
    {
      name: '全诊通',
      value: 1,
    },
    {
      name: '熙牛',
      value: 2,
    },
    {
      name: '浙江一山',
      value: 3,
    },
    {
      name: '浙江和仁',
      value: 4,
    },
    {
      name: '长兴渔湾',
      value: 5,
    },
  ]

  useEffect(() => {
    dispatch(getPartnerPlatformList({ size: 10, current: 1, status: 0 }))
      .then(unwrapResult)
      .then((res: any) => {
        setPlatformOption(
          res.records.map((el: any) => {
            return { value: el.id, label: el.platformName }
          })
        )
      })
  }, [])

  useEffect(() => {
    if (others.visible) {
      setVersionId('')
    }
  }, [others.visible])

  useEffect(() => {
    if (!others.visible) return
    tenantId ? getLabelList(tenantId) : getLabelList()
  }, [others.visible])
  const getLabelList = (tenantId?: string) => {
    !tenantId && setSelectedTags([])
    dispatch(
      //获取标签
      getTenantLabelList({ tenantId })
    )
      .then(unwrapResult)
      .then((res) => {
        tenantId &&
          setSelectedTags(
            res
              .filter((val: any) => val.status == 1)
              .map((item: any) => {
                return item.id
              })
          )

        setLabelList(res)
      })
  }
  // 省
  useEffect(() => {
    if (others?.visible) {
      dispatch(getProvinceList({ regionLevel: 1, size: 1000 }))
        .then(unwrapResult)
        .then((t: any) => setProvinceList(t?.records))
    }
  }, [others.visible])

  // 市
  useEffect(() => {
    if (showData?.provinceName || provinceState) {
      dispatch(
        getProvinceList({
          regionLevel: 2,
          parentRegionCode: provinceState || showData?.provinceCode,
          size: 1000,
        })
      )
        .then(unwrapResult)
        .then((t: any) => setCityList(t?.records))
    }
  }, [provinceState, showData?.provinceName])

  // 区
  useEffect(() => {
    if (showData?.provinceName || (provinceState && cityState)) {
      dispatch(
        getProvinceList({
          regionLevel: 3,
          parentRegionCode: cityState || showData?.cityCode,
          size: 1000,
        })
      )
        .then(unwrapResult)
        .then((t: any) => setAreaList(t?.records))
    }
  }, [provinceState, cityState, showData?.provinceName])

  useEffect(() => {
    if (others.visible) {
      if (tenantId) {
        dispatch(getTenantDetail(tenantId))
          .then(unwrapResult)
          .then((tenant) => {
            setVersionId(tenant?.versionId)
            setTenantIdList(tenant?.id)
            setShowData(tenant)
            form.setFieldsValue({
              ...tenant,
              // platformId: 1,
              dockingPlatform: whsjjkList?.find((v)=> v?.value == tenant?.dockingPlatform) ? Number(tenant?.dockingPlatform) :'',
              startTime: moment(tenant.startTime),
              endTime: moment(tenant.endTime),
              tenantType: tenant?.tenantType
                ? tenant?.tenantType
                    .toString()
                    .split(',')
                    ?.map((item: string) => Number(item))
                : [],
              hosType: tenant?.hosType == 0 ? 0 : 1,
              trialFlag: tenant?.trialFlag == 0 ? 0 : 1,
              isGray: tenant?.isGray == 1 ? 1 : 0,
            })
          })
        getLabelList(tenantId) //获取标签
      } else {
        form.resetFields()
      }
    }
  }, [tenantId, others.visible])

  return (
    <>
      <Modal
        {...others}
        title={`${tenantId ? '更新' : '新建'}机构`}
        width={1000}
        confirmLoading={isLoading}
        cancelText='取消'
        okText='确定'
        onCancel={(e) => {
          // if (tenantId) {
          form.resetFields()
          // }
          setName('')
          onCancel && onCancel(e)
          setCityList([])
          setAreaList([])
          setProvinceState('')
          setCityState('')
          setShowData('')
        }}
        onOk={(e) => {
          if (name || versionName) {
            form.validateFields().then((values) => {
              console.log(values, 'values')
              const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
              const format = 'YYYY/MM/DD 23:59:59'
              const startTime =
                values.startTime && values.startTime.format(format)
              const endTime = values.endTime && values.endTime.format(format)
              setIsLoading(true)
              if (tenantId) {
                dispatch(
                  createOrUpdateTenant({
                    ...values,
                    id: tenantId,
                    startTime,
                    endTime,
                    provinceName: undefined,
                    cityName: undefined,
                    countyName: undefined,
                    provinceCode:
                      reg.test(values.provinceName) == false
                        ? values.provinceName
                        : reg.test(showData.provinceCode) == false
                        ? showData.provinceCode
                        : null,
                    cityCode:
                      reg.test(values.cityName) == false
                        ? values.cityName
                        : reg.test(showData.cityCode) == false
                        ? showData.cityCode
                        : null,
                    countyCode:
                      reg.test(values.countyName) == false
                        ? values.countyName
                        : reg.test(showData.countyCode) == false
                        ? showData.countyCode
                        : null,
                    tenantType: values?.tenantType?.join(',') || undefined,
                    hosType: values?.hosType == 0 ? 0 : 1,
                    trialFlag: values?.trialFlag == 0 ? 0 : 1,
                    versionId: versionId,
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    notification.success({
                      message: '操作成功',
                    })
                    setIsLoading(false)
                    form.resetFields()
                    onOk && onOk(e)
                    setName('')
                    dispatch(getTenantList({ current: 1, size: 10 }))
                  })
                  .catch(() => {
                    setIsLoading(false)
                    setName('')
                    // onCancel && onCancel(e)
                  })
              } else {
                dispatch(
                  createOrUpdateTenant({
                    ...values,
                    id: tenantId,
                    startTime,
                    endTime,
                    provinceName: undefined,
                    cityName: undefined,
                    countyName: undefined,
                    provinceCode:
                      reg.test(values.provinceName) == false
                        ? values.provinceName
                        : reg.test(showData.provinceCode) == false
                        ? showData.provinceCode
                        : null,
                    cityCode:
                      reg.test(values.cityName) == false
                        ? values.cityName
                        : reg.test(showData.cityCode) == false
                        ? showData.cityCode
                        : null,
                    countyCode:
                      reg.test(values.countyName) == false
                        ? values.countyName
                        : reg.test(showData.countyCode) == false
                        ? showData.countyCode
                        : null,
                    tenantType: values?.tenantType?.join(',') || undefined,
                    hosType: values?.hosType == 0 ? 0 : 1,
                    trialFlag: values?.trialFlag == 0 ? 0 : 1,
                    versionId: versionId,
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    notification.success({
                      message: '操作成功',
                    })
                    setIsLoading(false)
                    form.resetFields()
                    onOk && onOk(e)
                    setName('')
                    dispatch(getTenantList({ current: 1, size: 10 }))
                  })
                  .catch(() => {
                    // onCancel && onCancel(e)
                    setIsLoading(false)
                    setName('')
                    // Do nothing.
                  })
              }
            })
          } else {
            notification.info({
              message: '请先选择版本',
            })
          }
        }}
      >
        <Form
          form={form}
          colon={false}
          autoComplete='off'
          initialValues={{
            organLevel: TenantLevel.Level1,
            tenantCategory: TenantCategory.Pharmacy,
            edition: 0,
          }}
        >
          <Row {...rowProps}>
            <Col {...colProps} span={8}>
              <Form.Item
                {...wideColumnLayout}
                label='合作平台'
                name='platformId'
                {...required}
              >
                <Select
                  showSearch
                  placeholder='请选择合作平台'
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  filterOption={false}
                  onSearch={(v: string) => {
                    dispatch(
                      getPartnerPlatformList({
                        size: 10,
                        current: 1,
                        status: 0,
                        platformName: v,
                      })
                    )
                      .then(unwrapResult)
                      .then((res: any) => {
                        setPlatformOption(
                          res.records.map((el: any) => {
                            return { value: el.id, label: el.platformName }
                          })
                        )
                      })
                  }}
                  onChange={(v) => {
                    console.log(123, v)
                  }}
                  notFoundContent={null}
                >
                  {platformOption.map((el: any) => (
                    <Select.Option key={el.value} value={el.value}>
                      {el.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col {...colProps} span={8}>
              <Form.Item
                {...wideColumnLayout}
                label='机构类型'
                name='tenantType'
                {...required}
              >
                <Select mode='tags' placeholder='请选择机构类型'>
                  {teantTypes.map((el: any) => (
                    <Select.Option key={el} value={el}>
                      {getTeantTypeName(el)}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col {...colProps} span={8}>
              <Form.Item
                {...middleColumnLayout}
                label='机构属性'
                name='hosType'
                {...required}
                initialValue={1}
              >
                <Radio.Group>
                  <Radio value={0}> 公立 </Radio>
                  <Radio value={1}> 民营 </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps} span={16}>
              <Form.Item
                {...wideColumnLayout}
                label='机构名称'
                name='name'
                {...required}
                rules={[
                  { required: true, message: '机构名称不能为空' },
                  { max: 500, message: '最长500位' },
                ]}
              >
                <Input maxLength={500} autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='机构略称'
                name='shortName'
                {...required}
                rules={[
                  { required: true, message: '机构略称不能为空' },
                  { max: 120, message: '最长120位' },
                ]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='机构VIP等级'
                name='organLevel'
              >
                <Select>
                  {TenantLevels.map((l) => (
                    <Select.Option key={l} value={l}>
                      {getTenantLevelName(l)}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                required
                {...middleColumnLayout}
                label='机构类别'
                name='tenantCategory'
              >
                <Select defaultValue={TenantCategory.Clinic}>
                  {[
                    TenantCategory.hospital,
                    TenantCategory.maternityHealthCenter,
                    TenantCategory.communityHealthServiceCenter,
                    TenantCategory.surgery,
                    TenantCategory.nursingHome,
                    TenantCategory.outpatientDepartment,
                    TenantCategory.Clinic,
                    TenantCategory.villageHealthClinic,
                    TenantCategory.emergencyCenter,
                    TenantCategory.clinicalLaboratory,
                    TenantCategory.specializedDiseasePreventionAndTreatmentInstitution,
                    TenantCategory.nursingStation,
                    TenantCategory.center,
                    TenantCategory.Pharmacy,
                    TenantCategory.other,
                    TenantCategory.blind,
                    TenantCategory.schoolHos,
                  ].map((c) => (
                    <Select.Option key={c} value={c}>
                      {getTenantCategoryName(c)}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='医疗机构编号'
                name='medicalOrganCode'
                rules={[{ max: 120, message: '最长120位!' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='医院编号'
                name='hospitalCode'
                rules={[{ max: 120, message: '最长120位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='服务起始时间'
                name='startTime'
                dependencies={['endTime']}
                {...required}
                rules={[
                  { required: true, message: '服务起始时间不能为空' },
                  ({ getFieldValue }) => ({
                    validator: (_, start) => {
                      if (start) {
                        const end = getFieldValue('endTime')
                        if (
                          end &&
                          moment.duration(end.diff(start)).asMinutes() < 0
                        ) {
                          return Promise.reject('起始时间必须早于终止时间')
                        }
                        return Promise.resolve()
                      }
                      return Promise.resolve()
                    },
                  }),
                ]}
              >
                <DatePicker disabled={!!tenantId} format='YYYY/MM/DD' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='服务终止时间'
                name='endTime'
                {...required}
                rules={[{ required: true, message: '服务终止时间不能为空' }]}
              >
                <DatePicker disabled={!!tenantId} format='YYYY/MM/DD' />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='医疗机构等级'
                name='medicalOrganLevel'
                {...required}
                rules={[{ required: true, message: '医疗机构等级不能为空' }]}
              >
                <Select>
                  {HospitalLevels.map((l) => (
                    <Select.Option key={l} value={l}>
                      {getTenantLevelName(l)}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='机构电话'
                name='tenantPhone'
                {...required}
                rules={[
                  { required: true, message: '机构电话不能为空' },
                  {
                    pattern: /^[-+0-9]+$/,
                    message: '请输入正确的电话',
                  },
                ]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                {...required}
                label='全国唯一识别码'
                name='nationUniqueCode'
                rules={[
                  { required: true, message: '全国唯一识别码不能为空' },
                  { max: 120, message: '最长120位!' },
                ]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='省'
                name='provinceName'
                {...required}
                rules={[{ required: true, message: '省不能为空' }]}
              >
                <Select
                  placeholder='请选择省级'
                  allowClear
                  onSelect={(c) => {
                    setProvinceState(c)
                  }}
                  onChange={() => {
                    form.setFieldsValue({
                      cityName: '',
                      countyName: '',
                    })
                  }}
                >
                  {provinceList?.map((d) => (
                    <Select.Option key={d.regionCode} value={d.regionCode}>
                      {d.fullPath}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='市'
                name='cityName'
                {...required}
                rules={[{ required: true, message: '市不能为空' }]}
              >
                <Select
                  allowClear
                  placeholder='请先选择省级'
                  onSelect={(c) => {
                    setCityState(c)
                  }}
                  onChange={() => {
                    form.setFieldsValue({
                      countyName: '',
                    })
                  }}
                >
                  {cityList?.map((d) => (
                    <Select.Option key={d.regionCode} value={d.regionCode}>
                      {d.regionName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                {...required}
                label='区'
                name='countyName'
                rules={[{ required: true, message: '区不能为空' }]}
              >
                <Select allowClear placeholder='请先选择省市级'>
                  {AreaList?.map((d) => (
                    <Select.Option key={d.regionCode} value={d.regionCode}>
                      {d.regionName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps} span={24}>
              <Form.Item
                {...wideColumnLayout}
                label='地址'
                name='address'
                {...required}
                rules={[
                  { required: true, message: '地址不能为空' },
                  { max: 500, message: '最长500位' },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='联系人'
                name='contactName'
                {...required}
                rules={[
                  { required: true, message: '联系人不能为空' },
                  { max: 60, message: '最长60位' },
                ]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='联系电话'
                name='phone'
                {...required}
                rules={[
                  { required: true, message: '联系电话不能为空' },
                  { max: 40, message: '最长40位' },
                ]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='邮编'
                name='postcode'
                {...required}
                rules={[{ max: 40, message: '最长40位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='机构代码'
                name='organCode'
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='主管单位'
                name='managerCompany'
                rules={[{ max: 40, message: '最长40位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='法人代表'
                name='legalPerson'
                rules={[{ max: 40, message: '最长40位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='许可证类型'
                name='licenceCategory'
                rules={[{ max: 60, message: '最长60位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='许可证号码'
                name='licenceNumber'
                rules={[{ max: 120, message: '最长120位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='许可证期限'
                name='licenceDeadline'
                rules={[{ max: 40, message: '最长40位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='院区代码'
                name='hosDistinctCode'
                rules={[{ max: 60, message: '最长60位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='是否试用版本'
                name='trialFlag'
                {...required}
                initialValue={0}
                rules={[{ required: true, message: '是否试用版本不能为空' }]}
              >
                <Radio.Group>
                  <Radio value={1}> 是 </Radio>
                  <Radio value={0}> 否 </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='是否开启灰度'
                name='isGray'
                {...required}
                initialValue={0}
                rules={[{ required: true, message: '是否开启灰度不能为空' }]}
              >
                <Radio.Group>
                  <Radio value={1}> 是 </Radio>
                  <Radio value={0}> 否 </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='卫健数据接口'
                name='dockingPlatform'
              >
                <Select>
                  {whsjjkList?.map((v) => {
                    return (
                      <Select.Option key={v?.value} value={v?.value}>
                        {v?.name}
                      </Select.Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='对接编码'
                name='dockingPlatformTenantId'
                rules={[{ max: 120, message: '最长120位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='对接密钥'
                name='dockingPlatformTenantKey'
                rules={[{ max: 120, message: '最长120位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col {...colProps}>
              <Form.Item
                {...firstColumnLayout}
                label='拓展信息1'
                name='expansionInfoN1'
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
            <Col {...colProps}>
              <Form.Item
                {...middleColumnLayout}
                label='拓展信息2'
                name='expansionInfoN2'
                rules={[{ max: 120, message: '最长120位' }]}
              >
                <Input autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <div style={{ width: '100%' }}>
            <Form.Item
              {...labelLayout}
              label='标签'
              name='labelIds'
              // {...required}
              // rules={[
              //   { required: true, message: '请选择标签！' },
              // ]}
            >
              {labelList.map((item: any) => (
                <CheckableTag
                  style={{
                    marginBottom: 5,
                    border: '1px solid #d2d2d2',
                    borderRadius: 3,
                  }}
                  key={item.id}
                  checked={selectedTags.indexOf(item.id) > -1}
                  onChange={(checked) => {
                    const nextSelectedTags = checked
                      ? [...selectedTags, item.id]
                      : selectedTags.filter((t) => t !== item.id)
                    form.setFieldsValue({
                      labelIds: nextSelectedTags.join(','),
                    })
                    setSelectedTags(nextSelectedTags)
                  }}
                >
                  {item.name}
                </CheckableTag>
              ))}
            </Form.Item>
          </div>
          <Col span={24}>
            <Form.Item
              {...wideColumnLayout}
              label='版本'
              name='edition'
              required={true}
            >
              <>
                {name || versionName ? (
                  <>
                    <span style={{ marginRight: 10 }}>
                      {name || versionName}
                    </span>
                  </>
                ) : (
                  ''
                )}
                <a
                  onClick={(v: any) => {
                    setIsChooseVersionModalVisible(true)
                    setVersionId(versionId)
                    setTenantIdList(tenantIdList)
                  }}
                >
                  选择版本
                </a>
              </>
              {/* <Radio.Group>
              <Radio value={0}> 通用版 </Radio>
              <Radio value={1}> 口腔专业版 </Radio>
            </Radio.Group> */}
            </Form.Item>
          </Col>
        </Form>
      </Modal>
      <ChooseVersionModal
        tenantIdList={tenantIdList}
        versionId={versionId}
        onChange={(v) => {
          console.log(v)
          setName(v)
        }}
        onChangeId={(v) => {
          console.log(v)
          setVersionId(v)
        }}
        visible={isChooseVersionModalVisible}
        onCancel={() => {
          setIsChooseVersionModalVisible(false)
        }}
        onOk={() => {
          setIsChooseVersionModalVisible(false)
        }}
      ></ChooseVersionModal>
    </>
  )
}
